export const DATE_FORMATS = {
  ISO_FORMAT_NO_TIMEZONE: 'YYYY-MM-DDTHH:mm:ss',
};
